module.exports = {"220112001":"云山街道","220112002":"平湖街道","220112003":"奢岭街道","220112004":"山河街道","220112100":"齐家镇","220112101":"太平镇","220112102":"鹿乡镇","220112270":"双营子回族乡（梅花鹿产业经济开发区）（省级）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220112.json
// module id = 560
// module chunks = 0